var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 164,
    viewBox: "0 0 177 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16344 7.16344 0 16 0H161C169.837 0 177 7.16344 177 16V84H161V20C161 17.7909 159.209 16 157 16H20C17.7909 16 16 17.7909 16 20V120C16 122.209 17.7909 124 20 124H95V140H16C7.16344 140 0 132.837 0 124V16Z",
    fill: "url(#paint0_linear_483_3670)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 126",
    d: "M26 44.2731C26 37.6393 32.9067 33.2644 38.9044 36.099L88.7314 59.649C89.2013 59.871 89.7462 59.8694 90.2148 59.6446L139.084 36.1972C145.069 33.3255 152 37.6876 152 44.3259C152 47.7938 150.011 50.9544 146.884 52.4546L91.1915 79.176C90.1051 79.6973 88.8415 79.701 87.752 79.186L31.1777 52.4472C28.0163 50.953 26 47.7698 26 44.2731Z",
    fill: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1935 39.7629C26.4397 41.0696 26 42.5996 26 44.2733C26 47.77 28.0163 50.9532 31.1777 52.4474L87.752 79.1862C88.8415 79.7012 90.1051 79.6975 91.1915 79.1762L146.884 52.4548C150.011 50.9546 152 47.794 152 44.3261C152 42.6511 151.559 41.1211 150.803 39.8156C149.912 41.3672 148.562 42.6499 146.884 43.4548L91.1915 70.1762C90.1051 70.6975 88.8415 70.7012 87.752 70.1862L31.1777 43.4474C29.4695 42.64 28.0956 41.3395 27.1935 39.7629Z",
    fill: "#D9DFFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.169 100C139.738 100 136.426 107.691 140.844 112.363L151.846 124H119C114.582 124 111 127.582 111 132C111 136.418 114.582 140 119 140H151.846L140.844 151.637C136.426 156.309 139.738 164 146.169 164C148.183 164 150.109 163.17 151.493 161.706L175.062 136.78C177.598 134.098 177.598 129.902 175.062 127.22L151.493 102.294C150.109 100.83 148.183 100 146.169 100Z",
    fill: "#D9DFFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_483_3670",
    x1: 88.5,
    y1: 0,
    x2: 88.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE0FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.1a5e2f02c85b21a043cbbef6873872c7.svg";
export { ForwardRef as ReactComponent };